import { HomePostFormPage } from './HomePostFormPage';
export default HomePostFormPage;
